import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDpd({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.119 13.496c-.056.012-.426.051-.564.029-.563-.092-.833-.38-.84-.88-.005-.533.217-.92.875-.948.112-.005.48.06.526.103l.003 1.696zm.85.617V9.547h-.853v1.497c-.08-.046-.429-.109-.703-.101-.913.025-1.59.746-1.572 1.626.024 1.15.703 1.634 1.767 1.701.545.035 1.199-.131 1.361-.157zM21.139 13.496c-.056.012-.427.051-.564.029-.563-.092-.834-.38-.84-.88-.006-.533.216-.92.875-.948.112-.005.48.06.525.103l.004 1.696zm.85.617V9.547h-.854v1.497c-.08-.046-.428-.109-.702-.101-.913.025-1.591.746-1.573 1.626.025 1.15.703 1.634 1.767 1.701.545.035 1.2-.131 1.362-.157zM15.448 11.21v4.288h.864l-.003-3.729a3.7 3.7 0 01.563-.053c.57.033.829.35.842.852.009.32-.098.586-.307.751-.157.125-.377.19-.63.197l.002.75c.397.011.8-.072 1.119-.278.413-.267.707-.858.691-1.42-.03-1.017-.601-1.595-1.766-1.62-.546-.011-1.209.18-1.375.263z"
        fill="#3C3D3B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.635 7.694l-3.45 1.881 3.829 2.227c.035.02.074.06.074.104v3.28c0 .046-.04.077-.045.08l-.229.127c-.035.02-.087.022-.139-.007l-.203-.112a.118.118 0 01-.055-.1v-2.901c0-.051-.056-.076-.093-.097L2 10.24v3.88c0 .086.082.184.152.226l3.453 2.037c.111.065.177.054.33-.023l3.413-2.014c.08-.047.157-.134.157-.231V10.24l-2.29 1.338c-.028.017-.08.023-.11.006l-.207-.12c-.042-.024-.079-.071-.08-.121l-.004-.242c-.001-.037.023-.084.055-.103l2.449-1.425-3.449-1.879a.27.27 0 00-.118-.022.265.265 0 00-.116.022z"
        fill="url(#DPD_svg__paint0_linear)"
      />
      <defs>
        <linearGradient
          id="DPD_svg__paint0_linear"
          x1={9.505}
          y1={7.672}
          x2={2}
          y2={7.672}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E12A27" />
          <stop offset={1} stopColor="#AF1E45" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgDpd
